import React from "react";
import styles from "./ContactDisplay.module.css";
import mail from "../../assets/icons/mail.svg";
import phone from "../../assets/icons/phone.svg";
import { useTranslation } from "react-i18next";

const ContactDisplay: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div>
      <div className={styles.container}>
        <div className={styles.contactGrid}>
          <div className={styles.contactTile}>
            <div className={styles.iconWrapper}>
              <img src={mail} alt="Mail" />
            </div>
            <h2>{t("contactDisplay.email")}</h2>
            <a
              href="mailto:contact@youthpassion.com"
              className={styles.contactInfo}
            >
              <p>contact@youthpassion.com</p>
            </a>
          </div>

          <div className={styles.contactTile}>
            <div className={styles.iconWrapper}>
              <img src={phone} alt="Phone" />
            </div>
            <h2>{t("contactDisplay.phone")}</h2>
            <a href="tel:+48123456789" className={styles.contactInfo}>
              <p>+48 123 456 789</p>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactDisplay;
